export default __webpack_public_path__ + "static/tetris-preview-mb-3-arg-2b07761df9f2144b9897e88824828368.png";